<template>
  <section
    class="component-a12b3dfe"
    resmed-component-name="store-locator/sleep-study-clinic"
  >
    <div class="component">
      <div class="container">
        <div class="stage">
          <!-- filters -->
          <div v-if="filters.active" class="filters">
            <header>
              <h4>Filters</h4>
              <a href="#" v-on:click.prevent="filters.active = false"></a>
            </header>
            <ul v-bind:class="{ empty: !filters.applied.length }">
              <li
                v-for="filter in filters.values"
                v-bind:class="{ 'is-active': filters.applied.includes(filter) }"
              >
                <!--
                                    client has opt for one filter only
                                    !filters.applied.includes(filter) && filters.applied.push(filter) || filters.applied.splice(filters.applied.indexOf(filter), 1)
                                -->
                <a
                  v-on:click.prevent="
                    (!filters.applied.includes(filter) &&
                      $set(filters.applied, 0, filter)) ||
                      (filters.applied = [])
                  "
                  href="#"
                  >{{ filter }}</a
                >
              </li>
            </ul>
            <div class="apply" v-if="filters.applied.length">
              <a
                href="#"
                v-on:click.prevent="filters.active = false"
                class="btn cta-pill filled-red"
                >Apply</a
              >
            </div>
          </div>

          <!-- details -->
          <div v-if="details.active" class="details">
            <header>
              <!-- no title -->
              <a href="#" v-on:click.prevent="details.active = false"></a>
            </header>
            <div class="item">
              <div class="content">
                <div class="mb-3">
                  <h4>{{ details.item.name }}</h4>
                  <p v-if="details.item.appointment">By appointment only</p>
                </div>

                <div class="meta">
                  <div>
                    <div class="address">
                      <p v-html="details.item.location.full"></p>
                    </div>
                    <p class="distance mt-3">
                      {{ parseFloat(details.item.distance).toFixed(1) }} miles
                      away
                    </p>
                  </div>
                  <div>
                    <ul>
                      <li class="phone">
                        <a
                          v-on:click="
                            $root.datalayer.push({
                              event: gtm.event,
                              action: 'Call',
                              location: details.item.name,
                            })
                          "
                          v-bind:href="`tel:${details.item.phone}`"
                          >{{ details.item.phone | format }}</a
                        >
                      </li>

                      <li class="directions">
                        <a
                          v-on:click="
                            $root.datalayer.push({
                              event: gtm.event,
                              action: 'Directions',
                              location: details.item.name,
                            })
                          "
                          target="_blank"
                          v-bind:href="`https://www.google.com/maps?daddr=${details.item.location.full}`"
                          >Directions</a
                        >
                      </li>

                      <li class="website" v-if="details.item.website">
                        <a
                          v-on:click="
                            $root.datalayer.push({
                              event: gtm.event,
                              action: 'View Website',
                              location: details.item.name,
                            })
                          "
                          target="_blank"
                          v-bind:href="details.item.website | protocol"
                          >Visit website</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="services-products">
                <h5>{{ acf.details }}</h5>
                <ul
                  v-bind:class="{
                    'column-count-2':
                      type === 'store locator' &&
                      details.item.filters.length > 1,
                  }"
                >
                  <li
                    v-for="filter in details.item.filters"
                    v-bind:class="filter | sanitize"
                  >
                    {{ filter }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- query ui -->
          <div v-if="!filters.active && !details.active" class="query-ui">
            <header v-if="layout === 'default'">
              <h2>{{ acf.headline }}</h2>
              <p v-html="acf.description"></p>
            </header>

            <!-- v-on:submit.prevent="submit" -->
            <form action="javascript:" method="get">
              <div class="input-group">
                <input
                  type="search"
                  class="form-control"
                  v-model="query"
                  v-bind:placeholder="placeholder"
                  ref="autocomplete"
                />
                <div class="input-group-append" v-on:click="_predictions()">
                  <span class="input-group-text"
                    ><img
                      alt="search-icon"
                      src="@/assets/images/search-icon.svg"
                  /></span>
                </div>
                <div
                  v-if="layout === 'results' && error === '' && filter"
                  class="filter"
                >
                  <a
                    href="#"
                    v-on:click.prevent="filters.active = true"
                    v-bind:class="{ 'is-active': filters.applied.length }"
                    >{{ $getTranslation("Filter", $route.params.region) }}</a
                  >
                </div>
              </div>
              <div v-if="error === 'no-results'" class="message--no-results">
                <span>No results found. Please enter a different address.</span>
              </div>
            </form>

            <div
              class="current-location"
              v-if="layout === 'default' || !results.length"
            >
              <button
                v-if="idle"
                class="btn cta-pill filled-red icon compass"
                v-on:click="_position()"
              >
                Or use my current location
              </button>
              <div v-else class="spinner"></div>
            </div>
          </div>

          <!-- supplies-online -->
          <supplies-online
            v-if="filter && (!results.length || filters.active)"
          ></supplies-online>

          <!-- results [ lg, xl ] -->
          <div
            class="results"
            v-if="
              !filters.active &&
              !details.active &&
              ['lg', 'xl'].includes($root.mode)
            "
          >
            <results v-bind:results="results"></results>
          </div>
        </div>

        <div
          class="map"
          v-show="
            (!details.active && ['xs', 'sm', 'md'].includes($root.mode)) ||
            ['lg', 'xl'].includes($root.mode)
          "
        >
          <google-maps
            v-bind:results="results"
            v-bind:marker.sync="marker"
          ></google-maps>
        </div>

        <!-- results [ xs, sm, md ] -->
        <div
          class="results"
          v-if="
            !filters.active &&
            !details.active &&
            ['xs', 'sm', 'md'].includes($root.mode)
          "
        >
          <results v-bind:results="results"></results>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import results from "../shared-support/component-a12b3dfe0-results";
import googleMaps from "../shared-support/google-maps";
import suppliesOnline from "../shared-support/supplies-online";
import scroll from "../../mixins/scroll";

export default {
  name: "component-a12b3dfe", // store locator and sleep study clinic
  props: ["acf", "endpoint", "type", "country"],
  components: {
    results,
    googleMaps,
    suppliesOnline,
  },
  mixins: [scroll],
  data() {
    return {
      gtm: {
        event: "",
      },
      idle: true,
      geolocation: {
        lat: undefined,
        lng: undefined,
      },
      radius: 50,
      layout: "default", // 'default', 'results'
      query: undefined,
      placeholder: "",
      filter: true,
      filters: {
        active: false,
        values: [
          "CPAP machine",
          "CPAP mask",
          "AirMini travel CPAP",
          "AirTouch memory foam mask",
        ],
        applied: [],
      },
      marker: {
        active: undefined,
        store: undefined,
      },
      details: {
        active: false,
        item: [],
      },
      autocomplete: undefined,
      response: [],
      error: "", // 'no-results'
    };
  },
  filters: {
    sanitize(value) {
      return value.replace(/\s/g, "-").toLowerCase();
    },
    format(value) {
      return value
        .replace(/[^0-9]/g, "")
        .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    },
    protocol(value) {
      return value.indexOf("://") > -1 ? value : `http://${value}`;
    },
  },
  computed: {
    results() {
      let arr = this.response.filter((item) => {
        if (!this.filters.applied.length) {
          return true;
        }

        return item.filters.some((val) => {
          return this.filters.applied.includes(val);
        });
      });

      arr.length && (this.layout = "results");
      return arr;
    },
  },
  watch: {
    radius(val) {
      val && this.submit();
    },
    geolocation(val) {
      if (val.lat && val.lng) {
        this.submit();
      }
    },
    "filters.active"(val) {
      this.$nextTick(() => {
        if (!val) {
          this._autocomplete();

          this.$root.datalayer.push({
            event: this.gtm.event,
            action: "Applied Filter",
            filter: this.filters.applied[0],
          });
        }
      });
    },
    "marker.active"() {
      this.details.active = false;
    },
    "details.active"(val) {
      if (val && ["xs", "sm", "md"].includes(this.$root.mode)) {
        this.scroll({ to: "html" });
      }

      this.$nextTick(() => {
        if (!val) {
          this._autocomplete();

          this.$root.datalayer.push({
            event: this.gtm.event,
            action: "Close Details",
            location: this.details.item.name,
          });
        } else {
          this.$root.datalayer.push({
            event: this.gtm.event,
            action: "Details",
            location: this.details.item.name,
          });
        }
      });
    },
  },
  methods: {
    _predictions(arg) {
      arg = arg || this.query;

      let service = new google.maps.places.AutocompleteService();
      let placesService = new google.maps.places.PlacesService(
        document.createElement("div")
      );

      // favor postal codes
      if (/^[0-9]{5}$/.test(arg)) {
        service.getPlacePredictions(
          {
            input: arg,
            types: ["(regions)"],
            componentRestrictions: { country: ["us", "ca"] },
          },
          (predictions) => {
            placesService.getDetails(
              { reference: predictions[0].place_id },
              (place) => {
                this._geolocation(place);
              }
            );
          }
        );
      } else {
        service.getPlacePredictions(
          {
            input: arg,
            offset: arg.length,
            types: ["geocode"],
            componentRestrictions: { country: ["us", "ca"] },
          },
          (predictions) => {
            placesService.getDetails(
              { reference: predictions[0].reference },
              (place) => {
                this.query = place.formatted_address;
                this._geolocation(place);
              }
            );
          }
        );
      }
    },
    _position() {
      this.idle = false;
      navigator.geolocation.getCurrentPosition((position) => {
        this.geolocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        this.$emit("navigator:geolocation");
      });
    },
    _geolocation(place) {
      this.geolocation = Object.assign({}, this.geolocation, {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });
    },
    _autocomplete() {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        {
          types: ["geocode"],
          componentRestrictions: { country: ["us", "ca"] },
        }
      );

      this.autocomplete.addListener("place_changed", () => {
        let place = this.autocomplete.getPlace();

        // reset radius
        this.radius = 50;

        // user pressed enter without selecting from the list
        if (!place.geometry) {
          this._predictions(place.name);
        }
        // user has selected from the autocomplete list
        else {
          this.query = place.formatted_address;
          this._geolocation(place);
        }
      });
    },
    submit() {
      this.error = "";
      axios
        .get(`//${location.hostname}${this.endpoint}`, {
          params: {
            country: this.country, // either US or CA
            radius: this.radius,
            lat: this.geolocation.lat,
            lng: this.geolocation.lng,
          },
        })
        .then((response) => {
          this.response = response.data;
          this.idle = true;

          !this.response.length && (this.error = "no-results");
        });
    },
  },
  mounted() {
    // pre-selected filter
    // example: #filter=cpap_machine
    let hash = window.location.hash.substring(1).replace("filter=", ""),
      arr = [
        "cpap_machine",
        "cpap_mask",
        "airmini_travel_cpap",
        "airtouch_mask",
      ]; // client request. do not change vals.

    let map = {
      cpap_machine: "CPAP machine",
      cpap_mask: "CPAP mask",
      airmini_travel_cpap: "AirMini travel CPAP",
      airtouch_mask: "AirTouch memory foam mask",
    };

    if (arr.includes(hash)) {
      this.filters.applied[0] = map[hash]; // apply filter
      this._position(); // navigator.geolocation
    }
  },
  created() {
    bus.$emit("navigation:reversed", true);

    switch (this.type) {
      case "sleep study clinic":
        this.placeholder = "Find a sleep clinic";
        this.filter = false;
        this.gtm.event = "sleepApneaTestLocatorClick";
        break;

      default:
        // 'store locator'
        this.placeholder = "Find a CPAP store";
        this.filter = true;
        this.gtm.event = "offlineStoreLocatorClick";
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-a12b3dfe {
  // -->
}

.component {
  %close-x {
    display: block;
    width: 1.25rem;
    height: 1.25rem;
    background-repeat: no-repeat;
    background-size: 1rem 1rem;
    background-position: center center;
    background-image: url(#{$assets}/images/icon-close-white.svg);
  }

  .spinner {
    margin: 0 auto;
    border-left-color: $cc-resmed-action-red;
  }

  .container {
    display: flex;
    flex-direction: column;

    @media (max-width: 991px) {
      max-width: 100%;
      padding-right: 0;
      padding-left: 0;
    }

    @media (min-width: 768px) {
      min-height: 730px;
    }

    @media (min-width: 992px) {
      padding-top: 1.5rem;
      flex-direction: row;
    }

    .stage {
      @media (min-width: 768px) {
        border: 1px solid $cc-resmed-grey-15;
      }

      @media (min-width: 992px) {
        width: 40%;
      }

      > .filters,
      > .details {
        header {
          display: flex;
          justify-content: flex-end;
          padding: 1rem 1.5rem;
          background-color: $cc-resmed-action-red;

          h4 {
            flex-grow: 1;
            color: $cc-resmed-white;
            margin: 0;
          }

          a {
            @extend %close-x;
          }
        }
      }

      > .filters {
        margin-bottom: 2rem;

        ul {
          list-style: none;

          @media (min-width: 768px) {
            margin-bottom: 1.75rem;
          }

          &.empty {
            border-bottom: 1px solid $cc-resmed-grey-15;
          }

          li {
            padding: 0;

            background-repeat: no-repeat;
            background-position: 1rem center;
            opacity: 0.5;
            transition: opacity 1s;

            &:nth-child(1) {
              background-size: 25px 21px;
              background-image: url(#{$assets}/images/icon-filters-machine.png);
            }
            &:nth-child(2) {
              background-size: 21px 25px;
              background-position: 1.25rem center;
              background-image: url(#{$assets}/images/icon-filters-masks.png);
            }
            &:nth-child(3) {
              background-size: 30px 20px;
              background-position: 0.875rem center;
              background-image: url(#{$assets}/images/icon-filters-travel.png);
            }
            &:nth-child(4) {
              background-size: 27px 18px;
              background-image: url(#{$assets}/images/icon-filters-foam.png);
            }

            &:hover {
              background-color: rgba($cc-resmed-grey-15, 0.6);
            }

            &.is-active {
              background-color: rgba($cc-resmed-grey-15, 0.6);
              opacity: 1;

              a {
                color: $cc-resmed-black;

                background-repeat: no-repeat;
                background-size: 0.75rem 0.75rem;
                background-position: calc(100% - 1.625rem) center;
                background-image: url(#{$assets}/images/icon-active-blue.png);
              }
            }

            a {
              display: block;
              color: $cc-resmed-black;
              padding: 1.125rem 1rem 1.125rem 3.5rem;
            }
          }
        }

        .apply {
          text-align: center;
          margin: 0 auto;
          padding-bottom: 2.5rem;
          border-bottom: 1px solid $cc-resmed-grey-15;

          @media (max-width: 767px) {
            padding-top: 2.5rem;
          }

          @media (min-width: 768px) {
            margin-bottom: 2.5rem;
          }
        }
      }

      > .details {
        .item {
          animation-duration: 1s;
          animation-name: fade-in-zoom;
        }

        .content {
          padding: 1.25rem;

          .meta {
            @extend %body-small;

            @media (min-width: 768px) {
              display: flex;
            }

            > div {
              &:first-child {
                margin-bottom: 1rem;
              }

              @media (min-width: 768px) {
                margin: 0;
                flex-grow: 1;

                &:first-child {
                  width: 60%;
                  padding-right: 3rem;
                }
                &:last-child {
                  width: 40%;
                }
              }
            }

            ul {
              list-style: none;

              li {
                margin-bottom: 1rem;
                padding-left: 1.5rem;

                background-repeat: no-repeat;
                background-size: 1rem 1rem;
                background-position: left center;

                &:last-child {
                  margin-bottom: 0;
                }

                &.phone {
                  background-image: url(#{$assets}/images/icon-phone-red.svg);
                }
                &.directions {
                  background-image: url(#{$assets}/images/icon-directions-red.svg);
                }
                &.website {
                  background-image: url(#{$assets}/images/icon-website-red.svg);
                }

                a {
                  color: $cc-resmed-action-red;
                }
              }
            }
          }

          h4 {
            margin-bottom: 0.25rem;

            + p {
              @extend %body-small-bold;
              font-style: italic;
            }
          }
        }

        .services-products {
          padding: 1.25rem 0;
          margin: 0 1.25rem;
          border-top: 1px solid $cc-resmed-grey-15;

          ul {
            list-style: none;

            &.column-count-2 {
              @media (min-width: 768px) {
                column-count: 2;
                column-gap: 4rem;

                li {
                  -webkit-column-break-inside: avoid;
                  page-break-inside: avoid;
                  break-inside: avoid-column;
                }
              }
            }

            li {
              @extend %body-small;
              padding: 0.5rem 0 0.5rem 2.625rem;
              background-repeat: no-repeat;

              &.cpap-machine {
                background-size: 25px 21px;
                background-position: left center;
                background-image: url(#{$assets}/images/icon-filters-machine.png);
              }
              &.cpap-mask {
                background-size: 21px 25px;
                background-position: 0.25rem center;
                background-image: url(#{$assets}/images/icon-filters-masks.png);
              }
              &.airmini-travel-cpap {
                background-size: 30px 20px;
                background-position: left center;
                background-image: url(#{$assets}/images/icon-filters-travel.png);
              }
              &.airtouch-memory-foam-mask {
                background-size: 27px 18px;
                background-position: 0.25rem 0.625rem;
                background-image: url(#{$assets}/images/icon-filters-foam.png);
              }
              &[class*="home"] {
                background-size: 23px 21px;
                background-position: 0.25rem 0.625rem;
                background-image: url(#{$assets}/images/icon-offers-at-home.png);
              }
              &[class*="clinic"] {
                background-size: 22px 26px;
                background-position: 0.25rem 0.625rem;
                background-image: url(#{$assets}/images/icon-offers-at-clinic.png);
              }
              &[class*="physician"] {
                background-size: 22px 26px;
                background-position: 0.25rem 0.625rem;
                background-image: url(#{$assets}/images/icon-remote-physician-consultation.png);
              }
            }
          }
        }
      }

      > .query-ui {
        padding: 2rem 1.5rem;
        text-align: center;
        margin: 0 auto;

        @media (min-width: 768px) and (max-width: 991px) {
          max-width: 60vw;
        }

        header {
          margin-bottom: 2rem;

          h2 {
            margin-bottom: 0.5rem;

            @media (min-width: 768px) and (max-width: 1199px) {
              font-size: 1.8125rem;
            }
          }
        }

        form {
          input[type="search"] {
            height: auto;
            padding: 0.825rem 1.25rem;

            &::placeholder {
              color: lighten($cc-resmed-black, 60%);
              font-size: 0.875rem;
            }

            &:focus {
              box-shadow: none;
              outline: 0;
              border-color: #ced4da;
            }
          }

          .input-group-text {
            padding: 0;
            border: 0;
            border-top-right-radius: 6px;
            border-bottom-right-radius: 6px;
            cursor: pointer;
            background-color: $cc-resmed-action-red;
          }

          .filter {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 0 0 0 1.5rem;

            a {
              display: block;
              @extend %body-small;
              color: $cc-resmed-black;

              &.is-active {
                color: $cc-resmed-pulse-blue;
                padding: 0 1rem 0 0;

                background-repeat: no-repeat;
                background-size: 0.75rem 0.75rem;
                background-position: right center;
                background-image: url(#{$assets}/images/icon-active-blue.png);
              }
            }
          }
        }

        .message--no-results {
          padding: 1rem 0;

          span {
            @extend %body-small-bold;
            font-style: italic;
          }
        }

        .current-location {
          min-height: 44px;
          margin: 1.25rem auto 0 auto;

          button {
            &:disabled {
              opacity: 0.5;
            }
          }
        }
      }
    }

    .map {
      background-color: #f0f0f0;

      @media (min-width: 992px) {
        width: 60%;
      }
    }
  }
}
</style>